import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import VueRouter from "vue-router";
import utils from './assets/utils'
Vue.config.productionTip = false

//swiper
import 'swiper/swiper-bundle.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Swiper, {Autoplay} from 'swiper';
Swiper.use([Autoplay]);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


Vue.use(ElementUI);

//公共函数
Vue.prototype.$utils = utils

/*解决页面路由重复报错 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//路由跳转后定位页面顶部
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})

Vue.use(VueRouter)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
